module.exports = __webpack_public_path__ + "img/plant.5f759abe.svg";